export default __webpack_public_path__ + "9c74e172f87984c48ddf5c8108cabe67.png";